// API Endpoints
const website = require('@/api/endpoints/website.js')
const auth = require('@/api/endpoints/auth.js')
const user = require('@/api/endpoints/user.js')
const domain = require('@/api/endpoints/domain.js')
const mailbox = require('@/api/endpoints/mailbox.js')
const paypal = require('@/api/endpoints/paypal.js')
const translate = require('@/api/endpoints/translate.js')
const sitemap = require('@/api/endpoints/sitemap.js')

// Export Endpoints
export default {
  website, auth, domain, user, mailbox, paypal, translate, sitemap
}
